import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  OnInit,
} from '@angular/core';
import { IconTypes } from '../../../../../standalones/components/pencil-icon/pencil-icon.component';
import { FlagsService, FLAGS } from '../../../../../services/flags.service';
import pdfjsLib from '../../../../../../assets/pdfjs-config';

export interface PDFPagePreview {
  isSelected: boolean;
  imageUrl?: string;
  pdfPage?: pdfjsLib.PDFPageProxy;
  width?: number;
  height?: number;
}

@Component({
  selector: 'app-pdf-preview-selector[pageItems]',
  templateUrl: './pdf-preview-selector.component.html',
  styleUrls: ['./pdf-preview-selector.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PdfPreviewSelectorComponent implements OnInit {
  @Input() fileName: string = '';
  @Input() pageItems: PDFPagePreview[] = [];
  @Output() selectedIndicesSubmitted = new EventEmitter<number[]>();
  @Output() cancelClicked = new EventEmitter<void>();

  renderPdfInFabricEnabled: boolean = false;

  protected readonly IconTypes = IconTypes;
  protected readonly FLAGS = FLAGS;

  constructor(protected flagsService: FlagsService) {
    this.renderPdfInFabricEnabled = this.flagsService.isFlagEnabled(FLAGS.RENDER_PDFS_IN_FABRIC);
  }

  ngOnInit(): void {
    // Select all pages by default
    this.selectAll();
  }

  private getUserSelectedPagesIndices(): number[] {
    const items: number[] = [];
    this.pageItems.forEach((item, index) => {
      if (item.isSelected) {
        items.push(index);
      }
    });

    return items;
  }

  // TODO: Refactor to an observable instead of getter
  get selectedPagesCount(): number {
    return this.pageItems.filter((item) => item.isSelected).length;
  }

  selectAll() {
    this.pageItems.forEach((item) => (item.isSelected = true));
  }

  deselectAll() {
    this.pageItems.forEach((item) => (item.isSelected = false));
  }

  toggleItemSelection(index: number) {
    this.pageItems[index].isSelected = !this.pageItems[index].isSelected;
  }

  onCancelClick() {
    this.cancelClicked.emit();
  }

  onNextClick() {
    const indices = this.getUserSelectedPagesIndices();
    this.selectedIndicesSubmitted.emit(indices);
  }
}
